<palantir-card
  [attr.activatable]="!isSingleWarranty"
  [attr.aria-selected]="isSelected"
  [class.not-clickable]="isSingleWarranty"
  class="group"
>
  <palantir-card-content class="gap-4">
    <div class="flex items-center justify-between">
      <palantir-text type="title" class="truncate">{{ warrantyForm.get('name')?.value }}</palantir-text>
      <palantir-tag [ngClass]="{ 'selected-tag': isSelected }" [color]="tag().color" prefix="circle-filled">
        {{ tag().label }}
      </palantir-tag>
    </div>

    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-1 w-full truncate">
        <palantir-text type="description">{{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.CARD.START_DATE' | translate }}</palantir-text>
        <palantir-text class="truncate">
          @let startDate = warrantyForm.get('coverageStartedAt')?.value;
          @if (startDate) {
            {{ startDate | date: 'dd/MM/yyyy' }}
          } @else {
            {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.EMPTY' | translate }}
          }
        </palantir-text>
        @if (!startDate) {
          <palantir-icon
            name="info-outline"
            class="ml-1 cursor-pointer align-middle"
            style="color: var(--palantir-color-blue-70)"
            palantirTooltip="{{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.NO_ACTIVE_TOOLTIP' | translate }}"
            [palantirTooltipPosition]="'bottom'"
          ></palantir-icon>
        }
      </div>

      <div class="flex items-center gap-1 w-full truncate">
        <palantir-text type="description">{{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.CARD.END_DATE' | translate }}</palantir-text>
        <palantir-text class="truncate">
          @let endDate = warrantyForm.get('extendedCoverageEndedAt')?.value || warrantyForm.get('endDate')?.value;
          @if (endDate) {
            {{ endDate | date: 'dd/MM/yyyy' }}
          } @else {
            {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.EMPTY' | translate }}
          }
        </palantir-text>
      </div>
    </div>
  </palantir-card-content>
</palantir-card>
